/**
 * REEMPLAZA: frontend/src/pages/Login.js
 * Cambio: login en 2 pasos (contraseña → TOTP)
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { apiFetch } from "../api";
import { Input, Btn, C } from "../components/UI";

export default function Login() {
  const [step, setStep] = useState("password"); // password | totp
  const [form, setForm] = useState({ email: "", password: "" });
  const [totpCode, setTotpCode] = useState("");
  const [tempToken, setTempToken] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  // Paso 1: email + contraseña
  const submitPassword = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try {
      const res = await apiFetch("/auth/login", { method: "POST", body: JSON.stringify(form) });
      if (res.requires_totp) {
        setTempToken(res.temp_token);
        setStep("totp");
      } else {
        login(res.token, res.user);
        nav("/dashboard");
      }
    } catch(e) { setErr(e.message); }
    finally { setLoading(false); }
  };

  // Paso 2: código TOTP
  const submitTotp = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try {
      const res = await apiFetch("/auth/login/totp", {
        method: "POST",
        body: JSON.stringify({ temp_token: tempToken, code: totpCode })
      });
      login(res.token, res.user);
      nav("/dashboard");
    } catch(e) {
      setErr(e.message);
      setTotpCode("");
    }
    finally { setLoading(false); }
  };

  // Auto-submit cuando el código tiene 6 dígitos
  const handleTotpChange = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 6);
    setTotpCode(val);
    if (val.length === 6) {
      setTimeout(() => document.getElementById("totp-submit")?.click(), 100);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: C.bg }}>
      <div style={{ width: 380, padding: "2.5rem", background: C.surface, borderRadius: "14px", border: `1px solid ${C.border}` }}>

        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <div style={{ fontWeight: 800, fontSize: "1.4rem", color: C.accent }}>{"</> CodePad"}</div>
          <div style={{ color: C.muted, fontSize: "0.83rem", marginTop: "4px" }}>
            {step === "password" ? "Ingresá a tu workspace" : "Verificación en dos pasos"}
          </div>
        </div>

        {/* Error */}
        {err && (
          <div style={{ background: "#2a1010", border: `1px solid ${C.error}`, color: C.error,
            borderRadius: "7px", padding: "9px 13px", marginBottom: "1rem", fontSize: "0.83rem" }}>
            {err}
          </div>
        )}

        {/* Paso 1: contraseña */}
        {step === "password" && (
          <form onSubmit={submitPassword} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <Input label="Email" type="email" value={form.email}
              onChange={e => setForm(p => ({...p, email: e.target.value}))} required autoFocus />
            <Input label="Contraseña" type="password" value={form.password}
              onChange={e => setForm(p => ({...p, password: e.target.value}))} required />
            <Btn type="submit" loading={loading} style={{ width: "100%", marginTop: "0.5rem" }}>
              Continuar →
            </Btn>
          </form>
        )}

        {/* Paso 2: TOTP */}
        {step === "totp" && (
          <form onSubmit={submitTotp} style={{ display: "flex", flexDirection: "column", gap: "1.25rem" }}>
            <div style={{ background: "#0a1a1a", border: `1px solid ${C.border}`, borderRadius: "10px",
              padding: "1rem", textAlign: "center" }}>
              <div style={{ fontSize: "1.8rem", marginBottom: "6px" }}>📱</div>
              <div style={{ fontSize: "0.83rem", color: C.muted, lineHeight: 1.6 }}>
                Abrí Authy o Google Authenticator<br />e ingresá el código de 6 dígitos
              </div>
            </div>

            <div style={{ textAlign: "center" }}>
              <input
                value={totpCode}
                onChange={handleTotpChange}
                placeholder="000000"
                autoFocus
                inputMode="numeric"
                style={{
                  background: "#1a1a22", border: `2px solid ${totpCode.length===6 ? C.accent : C.border}`,
                  color: C.text, borderRadius: "10px", padding: "14px 20px",
                  fontSize: "2rem", fontFamily: "'JetBrains Mono',monospace",
                  letterSpacing: "0.4em", textAlign: "center", width: "100%",
                  transition: "border-color 0.15s",
                }}
              />
            </div>

            <Btn id="totp-submit" type="submit" loading={loading}
              style={{ width: "100%" }} disabled={totpCode.length !== 6}>
              Verificar
            </Btn>

            <button type="button" onClick={() => { setStep("password"); setErr(""); setTotpCode(""); }}
              style={{ background: "none", border: "none", color: C.muted, fontSize: "0.8rem", cursor: "pointer" }}>
              ← Volver
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
